export const editScreenButtonDataSet = { cy: 'edit-screen-button' };
